import { Component } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-unauthenticated-menu',
  standalone: false,
  templateUrl: './unauthenticated-menu.component.html',
  styleUrl: './unauthenticated-menu.component.css'
})
export class UnauthenticatedMenuComponent {

  constructor(private languageService: LanguageService) {
  }

  switchLang(lang: string) {
    this.languageService.setLanguage(lang);
  }

  isHighlighted(lang: string) {
    const currentLanguage = this.languageService.getCurrentLang();
    return lang === currentLanguage;
  }
}
